import './imagelink.less'

import {Component} from '@codeurs/front'
import m from 'mithril'
import {LinkType} from 'types/types'

export default class ImageLink extends Component<{image_link: LinkType}> {
	view() {
		const {image_link} = this.attrs
		if (!image_link || !image_link.url) return this.children
		return m('a.imagelink',
			{
				href: image_link.url,
				target: image_link.type === 'file' ? '_blank' : image_link.target
			},
			this.children
		)
	}
}
